import React from 'react';
import { observer } from 'mobx-react';

import style from './CertificateSigningForm.module.scss';

import { Popup } from '@components/Popup';
import { Select } from '@components/Select';
import { Button, ButtonTheme } from '@components/Button';

import { useCertificate } from './hooks/useCertificate';
import { useSignatureUploader } from './hooks/useSignatureUploader';
import { translate } from '@chaika/i18n/helper';
import { store } from '@store';

interface Props {
    withoutRootPopup?: boolean;
    onCloseClick(): void;
}

export const CertificateSignForm = observer(({ onCloseClick, withoutRootPopup }: Props): React.ReactElement<any> => {
    const { certificateOptions, selectCertificate, signData } = useCertificate();
    const {
        authUserCertificates: { selectedCertificate },
    } = store;
    const { isSigning, signWithEDS } = useSignatureUploader({ signData, onSigningFinish: onCloseClick });

    const component = (
        <div className={style.root}>
            <h1>{translate('signFileWithECP')}</h1>
            <div className={style.select}>
                <Select
                    dataTest={'EDS_certificate_select'}
                    locked={certificateOptions.length === 1}
                    title={translate('selectCertText')}
                    selectedValue={selectedCertificate?.thumbprint}
                    options={certificateOptions}
                    onChange={selectCertificate}
                />
            </div>
            <div className={style.actions}>
                <Button
                    disabled={isSigning}
                    dataTest={'EDS_sign_button'}
                    label={translate('signWithECP')}
                    onClick={signWithEDS}
                />
                <Button
                    disabled={isSigning}
                    theme={ButtonTheme.Secondary}
                    dataTest={'EDS_cancel_button'}
                    label={translate('cancel')}
                    onClick={onCloseClick}
                />
            </div>
        </div>
    );

    return (
        <>
            {withoutRootPopup ? (
                component
            ) : (
                <Popup
                    modifiers={[]}
                    onOutOfContentClick={isSigning ? undefined : onCloseClick}
                >
                    {component}
                </Popup>
            )}
        </>
    );
});
